import { useEffect, useState } from 'react';
import './contact.scss';
import { img_default_hands_app } from '../../../core/hooks/assetsConstants';
import InputGeneral from '../../../components/content/inputs/input_general/InputGeneral';
import { useContactServiceAdd } from '../../../core/hooks/services/contact.service';

export default function Contact({ setPageTitle }: any) {
  const namePage = 'Contacto';

  useEffect(() => {
    setPageTitle(namePage);
    document.title = `${namePage} | SeñaTech`;
  }, [setPageTitle]);

  const [formData, setFormData] = useState({
    fullname_contact: '',
    email_contact: '',
    issue_contact: '',
    message_contact: ''
  });

  const [errors, setErrors] = useState({
    fullname_contact: '',
    email_contact: '',
    issue_contact: '',
    message_contact: ''
  });

  const [msgSuccess, setMsgSuccess] = useState<string | null>(null);
  const [msgError, setMsgError] = useState<string | null>(null);
  const { content, loading } = useContactServiceAdd();

  useEffect(() => {
    if (msgSuccess) {
      const timer = setTimeout(() => setMsgSuccess(null), 5000);
      return () => clearTimeout(timer);
    }
  }, [msgSuccess]);

  useEffect(() => {
    if (msgError) {
      const timer = setTimeout(() => setMsgError(null), 5000);
      return () => clearTimeout(timer);
    }
  }, [msgError]);

  const validateField = (name: string, value: string) => {
    let errorMessage = '';
    if (name === 'fullname_contact') {
      errorMessage = !value.trim()
        ? 'Su nombre es obligatorio'
        : value.trim().split(' ').length < 2
          ? 'Debe incluir al menos un nombre y un apellido'
          : '';
    } else if (name === 'email_contact') {
      errorMessage = !value.trim()
        ? 'Su correo electrónico es obligatorio'
        : !/\S+@\S+\.\S+/.test(value)
          ? 'Debe ingresar un correo electrónico válido'
          : '';
    } else if (name === 'issue_contact' && !value.trim()) {
      errorMessage = 'El asunto es obligatorio';
    } else if (name === 'message_contact' && !value.trim()) {
      errorMessage = 'El mensaje es obligatorio';
    }

    setErrors(prevErrors => ({ ...prevErrors, [name]: errorMessage }));
    return errorMessage === '';
  };

  const validateAllFields = () => {
    let isValid = true;
    Object.keys(formData).forEach(field => {
      if (!validateField(field, formData[field as keyof typeof formData])) isValid = false;
    });
    return isValid;
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prevFormData => ({ ...prevFormData, [name]: value }));
    validateField(name, value);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!validateAllFields()) return;

    const result = await content(formData);
    if (result) {
      setMsgError("");
      setMsgSuccess("Mensaje enviado con éxito");
      setFormData({ fullname_contact: '', email_contact: '', issue_contact: '', message_contact: '' });
      setErrors({ fullname_contact: '', email_contact: '', issue_contact: '', message_contact: '' });
    } else {
      setMsgSuccess("");
      setMsgError("Error al enviar el mensaje");
    }
  };

  return (
    <section className='page content_contact'>
      <div className='title_content'>
        <h1 className='title'>Formulario de contacto</h1>
        <span className='description'>Si tiene dudas en relación con alguna de las expresiones del diccionario, déjenos sus comentarios llenando el siguiente formulario.</span>
      </div>

      <div className='form_content'>
        <img className='image_port' src={img_default_hands_app} alt="" />

        <form onSubmit={handleSubmit} className='form'>
          <InputGeneral
            nameClass='input'
            placeholder='Ingrese su nombre'
            type='text'
            value={formData.fullname_contact}
            onChange={handleInputChange}
            name='fullname_contact'
            errorMessage={errors.fullname_contact}
          />

          <InputGeneral
            nameClass='input'
            placeholder='Ingrese su correo electrónico'
            type='text'
            value={formData.email_contact}
            onChange={handleInputChange}
            name='email_contact'
            errorMessage={errors.email_contact}
          />

          <InputGeneral
            nameClass='input'
            placeholder='Ingrese el asunto del mensaje'
            type='text'
            value={formData.issue_contact}
            onChange={handleInputChange}
            name='issue_contact'
            errorMessage={errors.issue_contact}
          />

          <InputGeneral
            nameClass='input textarea'
            placeholder='Ingrese su mensaje...'
            type='textarea'
            value={formData.message_contact}
            onChange={handleInputChange}
            name='message_contact'
            errorMessage={errors.message_contact}
          />

          <div className='button_content'>
            <button type='submit' className='button_black' disabled={loading}>
              {loading ? "Enviando..." : "ENVIAR"}
            </button>
          </div>
        </form>
        {msgSuccess && <p className='message_success'>{msgSuccess}</p>}
        {msgError && <p className='message_error'>{msgError}</p>}
      </div>
    </section>
  );
}
